import React, { useEffect } from "react";
import { connect } from "react-redux";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";
import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import SelectActivityTypeField from "@app/component/input/SelectActivityTypeField";
import NylasForm from "@app/scene/settings/type/NylasForm";
import { convertNylesOptionsToSyncDirection } from "@app/scene/settings/util/syncDirection";
import { getActivityTypes } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";

import styles from "./SyncOptions.module.scss";

interface Props {
  activityTypes: ActivityType[];
  form: FormInstance<NylasForm>;
  onChange?: (value?: ActivityType) => void;
  value?: Pick<ActivityType, "id" | "name">;
}

const SyncDirectionDescription: React.FC<Props> = ({ activityTypes, form, onChange, value }) => {
  const intl = useIntl();
  const syncOptions = form.getFieldValue("syncOptions");

  useEffect(() => {
    if (!syncOptions.incoming) {
      return;
    }
    if (!value && activityTypes.length) {
      onChange?.(activityTypes[0]);
    }
  }, [activityTypes, syncOptions.incoming, onChange, value]);

  return (
    <>
      <div className={styles.description}>
        {intl.formatMessage(
          {
            id: "settings.calendar.createEditPane.syncDirection.description",
            defaultMessage:
              "{direction, select, outgoing {Map My Customers activities will appear in your calendar as events} incoming {Calendar events will appear in MMC as an activity type of your choice} two_way {Map My Customers activities will appear in your calendar as events. Calendar events will appear in MMC as an activity type of your choice} other {}}",
            description: "Settings calendar create/edit pane - sync direction - description",
          },
          { direction: convertNylesOptionsToSyncDirection(syncOptions) }
        )}
      </div>
      {!!syncOptions.incoming && (
        <SelectActivityTypeField
          className={styles.selector}
          onChange={(activityTypeId: Activity["id"]) => {
            onChange?.(activityTypes.find(({ id }) => activityTypeId === id));
          }}
          value={value?.id}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActivityTypes(state),
});

export default connect(mapStateToProps, {})(SyncDirectionDescription);
